// xl = not defined here -> everything that's bigger...
export enum ICON_SIZE {
  xs = 8,
  s = 16,
  m = 20,
  l = 24,
  custom = -1
}
